module.exports = __webpack_public_path__ + "media/audio12.8b35bbb3.mp3";